import type { CMSColumnsContainerDTO } from "~/CMSComponents/dto";
import { renderCMSComponent } from "~/CMSComponents/componentFactory";
import { styled } from "@mui/material";
import { makeExternallyStyledElement } from "~/CMSComponents/CMSExternalStyleHelper";

interface Props extends Omit<CMSColumnsContainerDTO, "type"> {
  className?: string;
}

const JUSTIFY_VALUES = {
  LEFT: "flex-start",
  CENTER: "center",
  RIGHT: "flex-end",
};

export const CMSColumnContainer = (props: Props) => {
  return (
    <StyledColumnContainer
      rootStyles={props.rootStyles}
      className={props.className}
      style={{ justifyContent: JUSTIFY_VALUES[props.alignment] }}
      id={props.htmlId}
    >
      {props.columns.map((column, index) => {
        return renderCMSComponent(column, undefined, index);
      })}
    </StyledColumnContainer>
  );
};

const ColumnContainer = styled("div")({
  display: "flex",
  margin: `calc(var(--gutter) / -2)`,
  flexFlow: "wrap",
});
const StyledColumnContainer = makeExternallyStyledElement(ColumnContainer);
